import $ from 'jquery';
import { startDialogBehaviour, stopDialogBehaviour } from "../utils/dialog-behaviour";

const body = $(document.body);

const popups = $('.popup');

popups.not('.cookie-popup').each(function () {
    body.append(this);
});

popups.on('toggle', function () {
    const self = $(this);

    if (self.hasClass('is-open')) {
        self.removeClass('is-open');
        self.addClass('is-closed');
        body.removeClass('popup-open');
        stopDialogBehaviour(this);
    } else {
        self.addClass('is-open');
        self.removeClass('is-closed');
        body.addClass('popup-open');
        startDialogBehaviour(this);
    }

});

document.body.addEventListener('click', function (e) {
    $('.popup.is-open').not('.cookie-popup').each(function () {
        if (!this.contains(e.target) && this !== e.target) {
            $(this).trigger('toggle');
        }
    });
}, { capture: true });

document.addEventListener('keyup', function (event) {
    if (event.key === 'Escape') {
        $('.popup.is-open').not('.cookie-popup').each(function () {
            $(this).trigger('toggle');
        });
    }
});
